
enum FieldItemType {
    text = "text",
    number = "number",
    textarea = "textarea",
    select = "select",
    file = "file",
    image = "image",
    checkbox = "checkbox",
    radio = "radio",
}

enum DataErrorType {
    neterr = "neterr"
}

interface FieldType {
    // 上传编号
    id: number
    // 选项类型
    item_type: FieldItemType,
    // 默认值
    item_value: string|Array<string>,
    // 展示名称
    name: string,
    // 是否必填
    necessary: 1|0,
    // 正确答案
    answer: string,
    // 链接新闻
    news_url?: string,
}

interface CollectType {
    info_cover_image:string,
    connection_id: number,
    connection_num: number,
    content: string,
    bg_image: string
    bt_image: string
    channel_code: string
    end_time: number
    id: number
    image: string
    is_share: number
    name: string
    share_bg_image: string
    share_content: string
    share_image: string
    share_title: string
    share_url: string
    show_num: number
    start_time: number
    status: number
}

interface DataType {
    collect?: CollectType
    fields?: FieldType[]
}

interface StateType {
    activityId: string
    userid: string
    imei: string
    bindPhone: string
    pageInfo: DataType
    postData: Map<string, string>
    submitLock: boolean
    // 1开始页2问答页3结果页
    currPage: 0|1|2|3
    // 选择答案集
    answers: AnswerType[]
    // 是否随机
    isSample: boolean
    // 总共需要答多少题
    totolSel: number
    // 选择的结果集
    selectAnswers: Map<string, SelectAnswer[]>
    // 答对的次数
    rightNum: number
}

export interface SelectAnswer {
    isRight: boolean,
    text: string,
}

export interface AnswerType {
    id: number
    title: string
    // 1单选2多选3图片
    type: FieldItemType
    answers: Array<{
        isRight: boolean,
        text: string,
    }>,
    news_url?: string,
}

export enum ItemType {
    radio = 'radio', checkbox = 'checkbox', image = 'image',
}

class UploadImageData {
    private _class = "";
    private _code = 0;
    private _id = "";
    private _msg = "";
    private _path = "";
    get class(): string {
        return this._class;
    }

    set class(value: string) {
        this._class = value;
    }

    get code(): number {
        return this._code;
    }

    set code(value: number) {
        this._code = value;
    }

    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    get msg(): string {
        return this._msg;
    }

    set msg(value: string) {
        this._msg = value;
    }

    get path(): string {
        return this._path;
    }

    set path(value: string) {
        this._path = value;
    }
}

export {
    FieldType,
    FieldItemType,
    DataType,
    DataErrorType,
    CollectType,
    StateType,
    UploadImageData,
}
